<template>
    <div style="position: fixed; top: 0; left: 0; width: 100%; z-index:3 background: #fff; height: 100%; z-index: 4">
        <button class="btn btn-delete-img" style="top: 70px; right: 5px; z-index: 4" @click="closePdf">
            <i class="icon-close-img"></i>
        </button>
        <div class="main-cnt block-image ex-preprocessing">
            <figure class="bill-fig" :class="{noimage:url_pdf== ''}" style="border: 0;">
                <div v-if="loadedRatio > 0 && loadedRatio < 1" style="background-color: green; color: white; text-align: center" :style="{ width: loadedRatio * 100 + '%' }">{{ Math.floor(loadedRatio * 100) }}%</div>
                <pdf
                    :src="url_pdf"
                    ref="pdf"
                    :page="page"
                    :rotate="rotate"
                    @progress="loadedRatio = $event"
                    @num-pages="numPages = $event"
                    @link-clicked="page = $event"
                ></pdf>
            </figure>
            <div class="nav-slide-pdf">
                <span v-for="(pageSelect, index) in numPages" :key="index" class="dot" :class="{active:pageSelect == selected}" @click="changePage(pageSelect)"></span>
            </div>
            <div v-if="false">
                <input v-model.number="page" type="number" style="width: 5em" :max="numPages" min="1"> /{{numPages}}
                <button @click="rotate += 90">&#x27F3;</button>
                <button @click="rotate -= 90">&#x27F2;</button>
            </div>
        </div>
    </div>
</template>
<script>
/* global Utils */
import VoucherManagementService from '@/services/module/voucher.service';
import pdf from 'vue-pdf';

export default {
    components: {
        pdf: pdf,
    },
    props: {
        voucher: {},
        closePdf: Function,
    },
    data () {
        return {
            url_pdf: "",
            loadedRatio: 0,
            page: 1,
            numPages: 0,
            rotate: 0,
            selected: 1,
        };
    },
    mounted () {
        if (this.voucher.has_file) {
            this.getPdf(this.voucher.id);
        }
    },
    methods: {
        getPdf (id) {
            if (id) {
                VoucherManagementService.getPdf(id)
                    .then(response => {
                        // console.log(response.status);
                        if (response.status == 423) {
                            StorageService.saveExpired();
                            AuthService.doLogout();
                        } else if (response.status != 200) {
                            let errorCode = Utils.getErrorCode(response);
                            if (errorCode) {
                                // console.log(errorCode);
                            }
                            this.url_pdf = '';
                        } else {
                            this.url_pdf = { data: response.data };
                        }
                    })
                    .catch(error => {
                        this.url_pdf = '';
                    });
            } else {
                this.url_pdf = '';
            }
        },
        changePage (pageSelect) {
            this.page = pageSelect;
            this.selected = pageSelect;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Voucher/PdfViewer.vue